class QuickviewProduct extends HTMLElement {
  constructor() {
    super();
    this.settings();
    this.els();
    this.listeners();
  }

  quickviewProductOpenUnsubscriber = undefined;

  connectedCallback() {
    this.quickviewProductOpenUnsubscriber = window.subscribe(PUB_SUB_EVENTS.quickviewProductOpen, event => {
      this.triggerEl = event.el;
      this.open(event.url);
    });
  }

  disconnectedCallback() {
    const unsubscribers = [
      this.swatchUnsubscriber,
      this.uomChangeUnsubscriber,
      this.variantChangeUnsubscriber,
    ];

    unsubscribers.forEach(unsubscriber => unsubscriber && unsubscriber());
  }

  settings() {
    this.activeClass = 'quickview-product--active';
    this.activeProductUrl = null;
    this.isOpen = false;
    this.transitionDuration = 250;
  }

  els() {
    this.closeEl = this.querySelector('[data-quickview-product-close]');
    this.modalEl = this.querySelector('[data-quickview-product-modal]');
  }

  listeners() {
    // close button
    this.closeEl.addEventListener('click', () => {
      this.close();
    });

    // close backdrop
    this.addEventListener('click', e => {
      if (e.target.closest('product-detail')) return;
      this.close();
    });

    // close esc
    document.addEventListener('onEsc', () => {
      this.close();
    });
  }

  close() {
    document.documentElement.classList.remove(this.activeClass);
    this.modalEl.close();

    setTimeout(() => {
      this.triggerEl.focus();
      this.triggerEl = null;
    }, this.transitionDuration);
  }

  loadingStateBegin() {
    this.triggerEl.classList.add('loading');
  }

  loadingStateEnd() {
    setTimeout(() => {
      this.triggerEl.classList.remove('loading');
    }, this.transitionDuration)
  }

  open(url) {
    if (this.activeProductUrl !== url) {
      this.activeProductUrl = url;
      this.loadingStateBegin();

      fetch(this.activeProductUrl)
        .then(response => response.json())
        .then(response => {
          const div = document.createElement('div');
          div.innerHTML = response['quickview-product'];
          this.querySelector('product-detail').outerHTML = div.querySelector('product-detail').outerHTML;

          this.resolveSubheaderPages();

          requestAnimationFrame(() => {
            this.loadingStateEnd();
            this.show();
            window.loadSwiper();
          });
        }).catch(error => {
          console.error('There was a problem with the fetch operation:', error);
        });
    } else {
      this.show();
    }
  }

  resolveSubheaderPages() {
    const el = this.querySelector('[data-subheader-pages]');
    if (!el) return;
    const pages = el.dataset.subheaderPages.split(',').map(p => p.trim()).filter(Boolean);
    if (pages.some(p => window.location.pathname === p)) {
      el.removeAttribute('hidden');
    }
  }

  show() {
    this.modalEl.showModal();

    requestAnimationFrame(() => {
      document.documentElement.classList.add(this.activeClass);
    });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  if (!customElements.get('quickview-product')) {
    customElements.define('quickview-product', QuickviewProduct);
  }
});
